import React from "react";

import { CellContext } from "@tanstack/react-table";

import type { LibreViewClinicPatient } from "@/models/LibreViewModel.ts";
import { patientFormattedName } from "@/models/UserModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { ColumnHeader } from "@/uiKit/organisms/PatientSync/columnHeader.tsx";

export const NameCell: React.FC<CellContext<LibreViewClinicPatient, string>> = ({ row }) => (
  <Typography variant="body">{patientFormattedName(row.original.lastName, row.original.firstName)}</Typography>
);

export const NameHeader: React.FC = () => <ColumnHeader translationKey="patientSync.libreviewTable.name" />;
